export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 6_00.ce8d7563.jpg";